<template>
  <product-list v-bind="forwarded">
    <template #default="slotProps">
      <slot name="default" v-bind="slotProps" />
    </template>
    <template #compare v-if="$feature.tempShowCompareOnPdpAndPlp">
      <product-compare-sticky @remove="removeCompareItem" />
    </template>
  </product-list>
</template>

<script lang="ts" setup>
import type { Emits, Props } from '#commerce/components/product/list/List.vue'
import ProductList from '#commerce/components/product/list/List.vue'

const props = defineProps<Props>()
const emits = defineEmits<Emits>()
const forwarded = useForwardPropsEmits(props, emits)

const { removeCompareItem } = useCompareStore()
</script>
